<template>
  <div class="canvas-container" id="canvas_container">
    <rd-editor-guides id="editor_guides">
      <div id="canvas_loader" class="loader"></div>

      <iframe id="canvas" class="row" ondrop="(event) => { event.preventDefault(); }"></iframe>
      <iframe style="display: none !important;" id="rd_canvas" class="row" ondrop="(event) => { event.preventDefault(); }"></iframe>
      <canvas id="canvas_overlay" class="canvas-overlay" style="display: none !important"></canvas>

      <rd-format-toolbar showArrow id="toolbar-rd" style="position: absolute"></rd-format-toolbar>
      <rd-highlighter id="element_highlighter" style="z-index: 999; top: 20px; left: 20px; position: absolute" type="element"></rd-highlighter>
      <rd-highlighter id="selector_highlighter" style="z-index: 9999; top: 220px; left: 220px; position: absolute" type="selector"></rd-highlighter>

      <div id="_canvas_highlighters">
        <div id="_canvas_element_highlighter" style="display: none">
          <div class="lbi-hover-label" id="hoveredElementTagDetails">
            <span class="lbi-hover-tag"></span>
            <div class="lbi-hover-sep" style="display: none"></div>
            <span class="lbi-syn-id" style="display: none"></span>
          </div>
          <div class="_paddingIndicator" padding></div>
          <div class="addIcon" id="_add_Hover_element_icon_highlighter" title="Add" onclick="_addElementClicked()">
            <i class="bx bx-plus"></i>
          </div>
        </div>
      </div>

      <div id="_canvas_element_selector" style="display: none">
        <div id="_selector_toolbar_outer">
          <div class="lbi-drag" id="_selector_drag_handle">
            <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="2" r="1.5" />
              <circle cx="6" cy="2" r="1.5" />
              <circle cx="2" cy="5.5" r="1.5" />
              <circle cx="6" cy="5.5" r="1.5" />
              <circle cx="2" cy="9" r="1.5" />
              <circle cx="6" cy="9" r="1.5" />
              <circle cx="2" cy="12.5" r="1.5" />
              <circle cx="6" cy="12.5" r="1.5" />
            </svg>
          </div>
          <div class="lbi-info-section" id="_selector_tag_info">
            <span class="lbi-selected-tag-box" id="_selector_tag_name"></span>
          </div>
          <div id="_selected_element_toolBars"></div>
        </div>
      </div>

      <div id="_canvas_element_drag_placeholder" style="display: none"><span>&#8630;</span></div>
      <div id="_canvas_element_drag_overlay"></div>

      <div id="canvas_inline_editor_toolbar" style="display: none">
        <div class="inline_toolbars_items">
          <span class="inline_editor_toolbar" title="Bold" onclick="RichText.bold()" onmousedown="event.preventDefault()">
            <i class="bx bx-bold"></i>
          </span>
          <span class="inline_editor_toolbar" title="Italic" onclick="RichText.italic()">
            <i class="bx bx-italic"></i>
          </span>
          <span class="inline_editor_toolbar" title="Underline" onclick="RichText.underline()">
            <i class="bx bx-underline"></i>
          </span>
          <span class="inline_editor_toolbar" title="Strikethrough" onclick="RichText.strikeThrough()">
            <i class="bx bx-strikethrough"></i>
          </span>
          <span class="inline_editor_toolbar" title="Superscript" onclick="RichText.superscript()">
            <i class="bx bx-superscript"></i>
          </span>
          <span class="inline_editor_toolbar" title="Subscript" onclick="RichText.subscript()">
            <i class="bx bx-subscript"></i>
          </span>
          <span class="inline_editor_toolbar" title="Link" onclick="RichText.link()">
            <i class="bx bx-unlink"></i>
          </span>
        </div>
      </div>
    </rd-editor-guides>

    <span id="_hor_tree_more_details" class="hor-tree-more-details" style="display: none">&lt;TAG&gt;</span>
    <rd-breadcrumbs id="canvas_breadcrumbs" class="canvas-breadcrumbs"></rd-breadcrumbs>
    <div id="current_horizotal_element_tree" class="current-horizotal-element-tree" style="display: none" :if-empty="'Select an element'">
      <span class="current-horizotal-element-tree-body is-hover-color">Select an element</span>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  const fullToolbar = document.getElementById('toolbar-rd');
  if (!fullToolbar) return;

  fullToolbar.items = [
    {
      type: 'dropdown',
      id: 'fontFamily',
      tooltip: 'Font Family',
      label: 'Arial',
      dropdown: {
        searchable: false,
        items: [
          { label: 'Arial', value: 'Arial', icon: '<i class="bx bx-font-family"></i>' },
          { label: 'Georgia', value: 'Georgia', icon: '<i class="bx bx-font-family"></i>' },
          { label: 'Helvetica', value: 'Helvetica', icon: '<i class="bx bx-font-family"></i>' },
          { label: 'Times New Roman', value: 'Times New Roman', icon: '<i class="bx bx-font-family"></i>' },
          { label: 'Courier New', value: 'Courier New', icon: '<i class="bx bx-code"></i>' },
          { label: 'Verdana', value: 'Verdana', icon: '<i class="bx bx-font-family"></i>' },
        ],
        onSelect: (item) => { document.execCommand('fontName', false, item.value); },
      },
    },
    {
      type: 'dropdown',
      id: 'fontSize',
      icon: '<i class="bx bx-font-size"></i>',
      tooltip: 'Font Size',
      label: 'Normal',
      dropdown: {
        items: [
          { label: 'Small', value: '1', preview: 'S' },
          { label: 'Normal', value: '3', preview: 'M' },
          { label: 'Large', value: '5', preview: 'L' },
          { label: 'Huge', value: '7', preview: 'XL' },
        ],
        onSelect: (item) => { document.execCommand('fontSize', false, item.value); },
      },
    },
    { type: 'divider' },
    { type: 'button', id: 'bold', icon: '<i class="bx bx-bold"></i>', tooltip: 'Bold (Ctrl+B)', command: 'bold' },
    { type: 'button', id: 'italic', icon: '<i class="bx bx-italic"></i>', tooltip: 'Italic (Ctrl+I)', command: 'italic' },
    { type: 'button', id: 'underline', icon: '<i class="bx bx-underline"></i>', tooltip: 'Underline (Ctrl+U)', command: 'underline' },
    { type: 'button', id: 'strikethrough', icon: '<i class="bx bx-strikethrough"></i>', tooltip: 'Strikethrough', command: 'strikeThrough' },
    { type: 'divider' },
    {
      type: 'color-picker', id: 'textColor', icon: '<i class="bx bx-font-color"></i>', tooltip: 'Text Color', value: '#000000',
      onClick: (item) => { document.execCommand('foreColor', false, item.value); },
    },
    {
      type: 'color-picker', id: 'bgColor', icon: '<i class="bx bx-paint"></i>', tooltip: 'Background Color', value: '#ffff00',
      onClick: (item) => { document.execCommand('backColor', false, item.value); },
    },
    { type: 'divider' },
    {
      type: 'dropdown', id: 'align', icon: '<i class="bx bx-align-left"></i>', tooltip: 'Text Alignment',
      dropdown: {
        items: [
          { label: 'Left', value: 'left', icon: '<i class="bx bx-align-left"></i>' },
          { label: 'Center', value: 'center', icon: '<i class="bx bx-align-middle"></i>' },
          { label: 'Right', value: 'right', icon: '<i class="bx bx-align-right"></i>' },
          { label: 'Justify', value: 'justify', icon: '<i class="bx bx-align-justify"></i>' },
        ],
        onSelect: (item) => {
          const commands = { left: 'justifyLeft', center: 'justifyCenter', right: 'justifyRight', justify: 'justifyFull' };
          document.execCommand(commands[item.value], false);
        },
      },
    },
    { type: 'divider' },
    { type: 'button', id: 'bulletList', icon: '<i class="bx bx-list-ul"></i>', tooltip: 'Bullet List', command: 'insertUnorderedList' },
    { type: 'button', id: 'numberList', icon: '<i class="bx bx-list-ol"></i>', tooltip: 'Numbered List', command: 'insertOrderedList' },
    { type: 'divider' },
    {
      type: 'button', id: 'link', icon: '<i class="bx bx-link"></i>', tooltip: 'Insert Link',
      onClick: () => { const url = prompt('Enter URL:'); if (url) document.execCommand('createLink', false, url); },
    },
    {
      type: 'button', id: 'image', icon: '<i class="bx bx-image"></i>', tooltip: 'Insert Image',
      onClick: () => { const url = prompt('Enter image URL:'); if (url) document.execCommand('insertImage', false, url); },
    },
    { type: 'divider' },
    {
      type: 'dropdown', id: 'heading', label: 'Para', tooltip: 'Heading Level',
      dropdown: {
        items: [
          { label: 'Paragraph', value: 'p', preview: 'P' },
          { label: 'Heading 1', value: 'h1', preview: 'H1' },
          { label: 'Heading 2', value: 'h2', preview: 'H2' },
          { label: 'Heading 3', value: 'h3', preview: 'H3' },
        ],
        onSelect: (item) => { document.execCommand('formatBlock', false, item.value); },
      },
    },
    { type: 'divider' },
    {
      type: 'input', id: 'wordSpacing',
      input: {
        type: 'text', placeholder: '1.5px', value: '', min: -10, max: 50, step: 1, width: '60px',
        onInput: (value) => { console.log('Word Spacing input:', value); },
        onChange: (value) => { console.log('Word Spacing changed:', value); },
      },
    },
    { type: 'divider' },
    { type: 'button', id: 'clear', icon: '<i class="bx bx-eraser"></i>', tooltip: 'Clear Formatting', command: 'removeFormat' },
  ];

  fullToolbar.addEventListener('toolbar-command', (e) => {
    const { command, value } = e.detail;
    document.execCommand(command, false, value);
  });
});
</script>
